import { useEffect } from 'react';
import { api } from '../api/client';
import { useQuery } from '../hooks/useApi';
import { useAuth } from '../hooks/useAuth';
import { useI18n } from '../i18n';

/**
 * Quantas pessoas estão no site agora. Só o admin vê.
 *
 * Relê de tempos em tempos em vez de manter uma conexão aberta: para um número
 * que muda devagar, um SSE por aba do painel custaria mais do que entrega. A
 * contagem do servidor é de memória, então cada leitura é barata.
 */
const INTERVALO_MS = 20_000;

export function OnlineBadge() {
  const { isAdmin } = useAuth();
  const { lang } = useI18n();
  const { data, refetch } = useQuery(() => api.adminOnline(), [], isAdmin);

  useEffect(() => {
    if (!isAdmin) return;
    const timer = setInterval(refetch, INTERVALO_MS);
    // Voltar para a aba relê na hora: quem volta ao painel quer o número de
    // agora, e não o de quando saiu.
    const aoVoltar = () => {
      if (document.visibilityState === 'visible') refetch();
    };
    document.addEventListener('visibilitychange', aoVoltar);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', aoVoltar);
    };
  }, [isAdmin, refetch]);

  if (!isAdmin || !data) return null;

  const minutos = Math.max(1, Math.round(data.janelaSegundos / 60));
  const titulo =
    lang === 'pt'
      ? `${data.online} pessoa(s) no site nos últimos ${minutos} min — ${data.logados} com conta Steam`
      : `${data.online} on the site in the last ${minutos} min — ${data.logados} signed in with Steam`;

  return (
    <span className="online-badge" title={titulo}>
      <i aria-hidden />
      👥 {data.online}
    </span>
  );
}
